module.exports = __webpack_public_path__ + "img/Proximity_Fit.48063526.jpg";